import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';



// WEBPACK FOOTER //
// ./src/app/rxjs-extension.ts